import { useState, useEffect, useRef } from "react";
import moment from "moment";
import InputDate from "../../components/form/InputDate";
import Select from "../../components/form/select/Select";
import ModalDefault from "../../components/ModalDefault";
import api from "../../services/api";
import message from "../../services/message";
import axios from "axios";
import { Container } from "../../styles/layout";
import {
  IconAdd,
  IconArrow,
  IconDetails,
  IconEdit,
  IconFilter,
  IconRemove,
} from "../../components/layout/Svgs";

import {
  HeaderPonto,
  SectionFilterPonto,
  SectionTablePonto,
  SectionDetailsPonto,
  SectionRegisterPonto,
  ContainerPonto,
} from "./styles";
import ButtonDownload from "../../components/form/ButtonDownload/ButtonDownload";
import { ContainerModal, SectionModal } from "../../components/layout/styles";
import Input from "../../components/form/input/Input";
import Paginate from "../../components/paginate/Paginate";


export default function EntradasListar() {

  const [load, setLoad] = useState(false);
  const [modal, setModal] = useState(false);

  const [replicacao, setReplicacao] : any = useState(null)

  const [selectedFile, setSelectedFile] : any = useState(null);
  const fileInputRef : any = useRef(null);

  const [entradas, setEntradas] : any = useState({})
  const [page, setPage] = useState<any>(1);
  const [newEntrada, setNewEntrada] = useState({
    entradaId: null,
    contratoId:null,
    clienteId:null,
    contaId:null,
    tipoPagamentoId:null,
    valorBruto:'',
    valorLiquido:'',
    arquivo:'',
    data:moment().format('YYYY-MM-DD'),
    dataPagamento:moment().format('YYYY-MM-DD'),
    statusPagamento:'pendente',
    status:'ativo'
  })

  const [contratos, setContratos] = useState([])
  const [tiposPagamentos, setTiposPagamentos] = useState([])
  const [contas, setContas] = useState([])

  useEffect(() => {
    getEntradas()
    getContratos()
    getTiposPagamento()
    getContas()

    if (selectedFile) {
      handleUpload();
    }

  }, [selectedFile,page])

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    // Atualiza o estado com o arquivo selecionado
    await setSelectedFile(event.target.files && event.target.files[0]);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
  };

  const handleUpload = async () =>  {

    // Verifica se um arquivo foi selecionado
    if (!selectedFile) {
      console.log("Nenhum arquivo selecionado");
      return;
    }

    // Cria um objeto FormData para envolver o arquivo
    const formData = new FormData();
    formData.append('file', selectedFile);

    // Adiciona os headers necessários
    const headers = {
      Authorization: 'eyJhbGciOiJIUzI1NiJ9.Z3VpbGhlcm1lQHRyb3BhLmRpZ2l0YWx8fDIwMjQtMDEtMzBUMTc6NDE6MjQuNDIzWg.kOgosOkVSVyj05bqirzFLA29o7b8wYbIC9GKz-HDI0Q',
      Destination: 'tropafinanceiro',
    };

    try {
      // Envia a solicitação usando o Axios
      const response = await axios.post('https://bucket.backendtropa.com.br/upload', formData, {
        headers,
      });

      setNewEntrada({
        ...newEntrada,
        arquivo:response?.data?.arquivo,
      })


      // Limpa o estado para permitir novos uploads
      //setSelectedFile(null);
    } catch (error) {
      console.error('Erro no upload:', error);
    }
  };

  const handleChooseFile = () => {
    // Aciona o clique no input file quando o botão personalizado é clicado
    if(fileInputRef?.current){
      fileInputRef?.current!.click();
    }
    
  };

  async function getEntradas(){
    try{
      let response : any =  await api.get(`/entrada?paginate=true&page=${page}`)
      setEntradas(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function getContratos(){
    try{
      let response : any =  await api.get(`/contrato`)
      setContratos(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function getTiposPagamento(){
    try{
      let response : any =  await api.get(`/tipo-pagamento`)
      setTiposPagamentos(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function getContas(){
    try{
      let response : any =  await api.get(`/conta`)
      setContas(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function resetEntrada(){
    setNewEntrada({
      entradaId: null,
      contratoId:null,
      clienteId:null,
      contaId:null,
      tipoPagamentoId:null,
      valorBruto:'',
      valorLiquido:'',
      arquivo:'',
      data:moment().format('YYYY-MM-DD'),
      dataPagamento:moment().format('YYYY-MM-DD'),
      statusPagamento:'pendente',
      status:'ativo'
    })

    setModal(false)
  }

  function handleOnChangeReplicacao(name: string, value: string) {
    console.log(value)
    setReplicacao(value);
  }

  function handleOnChangeNewEntrada(name: string, value: string) {

    if (value) {
      setNewEntrada({ ...newEntrada, [name]: value });

      if(name == 'tipoPagamentoId'){
        // Remova os pontos de separação de milhares
        let valorLiquido : any = newEntrada.valorBruto.replace(/\./g, "");
        // Remova o símbolo "R$" e substitua a vírgula por um ponto
        valorLiquido = valorLiquido.replace("R$", "").replace(",", ".");
        
        let tipo :any = tiposPagamentos.filter(objeto => objeto['tipoPagamentoId'] == value);
        
        if(tipo[0] && tipo[0].deducao){
          let valorReal : any =  (parseFloat(valorLiquido) * parseFloat(tipo[0].deducao)) / 100
          valorLiquido = parseFloat(valorLiquido) - parseFloat(valorReal)
        }

        valorLiquido = parseFloat(valorLiquido).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });

        setNewEntrada(newEntrada => ({
          ...newEntrada,
          valorLiquido: valorLiquido
        }));
      }
      

      if(name == 'valorBruto'){
        // Remova os pontos de separação de milhares
        let valorLiquido : any = value.replace(/\./g, "");
        // Remova o símbolo "R$" e substitua a vírgula por um ponto
        valorLiquido = valorLiquido.replace("R$", "").replace(",", ".");

        let tipo :any = tiposPagamentos.filter(objeto => objeto['tipoPagamentoId'] == newEntrada.tipoPagamentoId);
        
        if(tipo[0] && tipo[0].deducao){
          let valorReal : any =  (parseFloat(valorLiquido) * parseFloat(tipo[0].deducao)) / 100
          valorLiquido = parseFloat(valorLiquido) - parseFloat(valorReal)
        }

        valorLiquido = parseFloat(valorLiquido).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });

        setNewEntrada(newEntrada => ({
          ...newEntrada,
          valorLiquido: valorLiquido
        }));
      }

      if(name == 'contratoId'){
        let cliente :any = contratos.filter(objeto => objeto['contratoId'] == value);
        
        if(cliente[0] && cliente[0].clienteId){
          setNewEntrada(newEntrada => ({
            ...newEntrada,
            clienteId: cliente[0].clienteId
          }))
        }
      }

      
    } else {
      setNewEntrada({ ...newEntrada, [name]: ''});
    }

  }

  async function editarEntrada(id?: any) {
    try{
      if(id){
        let response = await api.get(`/entrada/${id}`)

        if(response.data.valorBruto){
          response.data.valor = parseFloat(response.data.valorBruto).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          });
        }

        if(response.data.valorLiquido){
          response.data.valor = parseFloat(response.data.valorLiquido).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          });
        }

        
        setNewEntrada(response.data)
      }else{
        resetEntrada()
      }
      
      setModal(true);
    } catch(error: any) {
      message.error(String(error?.response?.data?.message));
    }
  }

  async function saveEntrada(e:any){
    try{
      e.preventDefault();
      let response : any
      if(newEntrada.entradaId){
        response = await api.put(`/entrada/${newEntrada.entradaId}?replicacao=${replicacao}`,newEntrada)
        message.success(`Entrada Editada com Sucesso.`)
      }else{
        response = await api.post(`/entrada?replicacao=${replicacao}`, newEntrada)
        message.success(`Entrada Criada com sucesso`)
      }
      await getEntradas()
      resetEntrada()

    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function excluirEntrada(id:number){
    try{
      let response : any = await api.delete(`/entrada/${id}`)
      getEntradas()

      message.success(`Entrada Excluida com Sucesso.`)
    
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function changePage(page:any){
    setPage(page)
    getEntradas()
  }


  return (
    <Container>
      <HeaderPonto>
        <h1 className="titlePonto">Entradas</h1>
        <button
          style={{ margin: "0px", width: "100px", letterSpacing: "1px",verticalAlign:'middle' }}
          className="btn btn-primary"
          onClick={() =>  editarEntrada(null)}
        > 
          Adicionar 
          <i className="fa-solid fa-plus"></i>
        </button>
      </HeaderPonto>

      <SectionFilterPonto>
        <Select 
          theme="alt"
          placeholder="Pesquise aqui..."
          label="Técnico"
          name="tecnico"
          value={''}
          onChange={(name, value) => console.log('alal')}
          onClickReset={() => {}}
          styles={{ width: "100%", margin: "0px" }}
        >
          
            <option key={1} value={1}>{'Teste'}</option>
         
        </Select>

        <InputDate
          mask="date"
          label="Data Inicial"
          name="Data Inicial"
          onChange={(e) => console.log('alal')}
          value={''}
          maxLength={10}
          handleOnClearDate={() => console.log('alala')}
        />

        <InputDate
          mask="date"
          label="Data Final"
          name="Data Final"
          onChange={(e) => console.log('alalal')}
          value={''}
          maxLength={10}
          handleOnClearDate={() => console.log('alala')}
        />


        <button
          style={{ margin: "0px", width: "100px", letterSpacing: "1px" }}
          className="btn btn-secondary"
          onClick={(e:any) => console.log('alalal')}
        >
          Filtrar
          <IconFilter />
        </button>
      </SectionFilterPonto>

      <SectionTablePonto>
        <table className="default">
          <thead>
            <tr>
              <th>Data</th>
              <th>Data de Pagamento</th>
              <th>Cliente</th>
              <th>Contrato</th>
              <th>Conta</th>
              <th>Tipo de Pagamento</th>
              <th>Valor Bruto</th>
              <th>Valor Liquido</th>
              <th>Status Pagamento</th>
              <th>Editar</th>
              <th>Remover</th>
              
            </tr>
          </thead>

          <tbody>

          { entradas && entradas.data && entradas.data.length > 0 &&
              entradas.data.map((row:any, key:any) =>(
              <tr key={''}>
                <td>{row.data}</td>
                <td>{row.statusPagamento == 'pago' && row.dataPagamento}</td>
                <td>{row?.cliente?.nome}</td>
                <td>{row?.contrato?.nome}</td>
                <td>{row?.conta?.nome}</td>
                <td>{row?.tipoPagamento?.tipo}</td>
                <td>{parseFloat(row.valorBruto).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                      })}</td>
                <td>{parseFloat(row.valorLiquido).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                      })}</td>
                <td style={{textTransform:'uppercase'}}>{row.statusPagamento}</td>
                <td>
                  <button
                    className="btn"
                    onClick={() => editarEntrada(row.entradaId)}
                  >
                    <IconEdit />
                  </button>
                </td>
                <td>
                  <button
                    className="btn"
                    onClick={() => excluirEntrada(row.entradaId)}
                  >
                    <IconRemove />
                  </button>
                </td>
              </tr>
              ))
            }
          </tbody>
        </table>
        
      </SectionTablePonto>
      <Paginate
            total={entradas?.totalCount}
            lastPage={entradas?.totalPages}
            perPage={entradas?.perSize}
            currentPage={page}
            onClickPage={changePage}
          />
      <ModalDefault
        id="modalDefault"
        onClose={() => setModal(!modal)}
        visible={modal}
      >
        <ContainerModal>
          <SectionModal>
          <form onSubmit={saveEntrada}>
            <h1>Editar / Adicionar - Entrada</h1>
            <div className="field" style={{display:'flex',flexDirection:'row'}}>
              <div className="field" style={{width:'50%',flexDirection:'column'}}>
                <h4>Data</h4>
                <div className="input">
                <InputDate
                  mask="date"
                  label=""
                  name="data"
                  onChange={(e) => handleOnChangeNewEntrada("data", e.target.value)}
                  value={newEntrada.data}
                  maxLength={10}
                  handleOnClearDate={() => handleOnChangeNewEntrada}
                />
                </div>
              </div>
              <div className="field" style={{width:'50%',flexDirection:'column'}}>
                <h4>Data de Pagamento</h4>
                <div className="input">
                  <InputDate
                    mask="date"
                    label=""
                    name="data"
                    onChange={(e) => handleOnChangeNewEntrada("dataPagamento", e.target.value)}
                    value={newEntrada.dataPagamento}
                    maxLength={10}
                    handleOnClearDate={() => handleOnChangeNewEntrada}
                  />
                </div>
              </div>
            </div>

            <div className="field" style={{display:'flex',flexDirection:'row'}}>
              <div className="field" style={{width:'50%',flexDirection:'column'}} >
                <h4>Valor Bruto</h4>
                <div className="input">
                  <Input type="text" name="valorBruto" mask="money" value={newEntrada?.valorBruto} onChange={handleOnChangeNewEntrada}/>
                </div>
              </div>
              <div className="field" style={{width:'50%',flexDirection:'column'}}>
                <h4>Valor Liquido</h4>
                <div className="input">
                  <Input type="text" name="valorLiquido" readOnly={true}  value={newEntrada?.valorLiquido} onChange={handleOnChangeNewEntrada}/>
                </div>
              </div>
            </div>

            <div className="field">
              <h4>Tipo de Pagamento</h4>
              <div className="input">
                <Select name="tipoPagamentoId" onChange={handleOnChangeNewEntrada} value={newEntrada?.tipoPagamentoId ? newEntrada?.tipoPagamentoId : ''}>
                  <option value="">Selecione aqui...</option>
                  { tiposPagamentos && tiposPagamentos.length > 0 &&
                      tiposPagamentos.map((row:any, key:any) =>(
                        <option key={key} value={row.tipoPagamentoId}>{row.tipo} - {row.deducao} %</option>
                    ))
                  }
                </Select>
              </div>
            </div>

            <div className="field">
              <h4>Contrato</h4>
              <div className="input">
                <Select name="contratoId" onChange={handleOnChangeNewEntrada} value={newEntrada?.contratoId ? newEntrada?.contratoId : ''}>
                  <option value="">Selecione aqui...</option>
                  { contratos && contratos.length > 0 &&
                      contratos.map((row:any, key:any) =>(
                        <option key={key} value={row.contratoId}>{row.nome}</option>
                    ))
                  }
                </Select>
              </div>
            </div>

            <div className="field">
              <h4>Conta</h4>
              <div className="input">
                <Select name="contaId" onChange={handleOnChangeNewEntrada} value={newEntrada?.contaId ? newEntrada?.contaId : ''}>
                  <option value="">Selecione aqui...</option>
                  { contas && contas.length > 0 &&
                      contas.map((row:any, key:any) =>(
                        <option key={key} value={row.contaId}>{row.nome}</option>
                    ))
                  }
                </Select>
              </div>
            </div>
            <div className="field">
              <h4>Status Pagamento</h4>
              <div className="input">
                <Select name="statusPagamento" onChange={handleOnChangeNewEntrada} value={newEntrada?.statusPagamento ? newEntrada?.statusPagamento : ''}>
                  <option value="">Selecione aqui...</option>
                  <option value="pendente">PENDENTE</option>
                  <option value="pago">PAGO</option>
                  <option value="atraso">EM ATRASO</option>
                </Select>
              </div>
            </div>

            <div className="field">
              <h4>Arquivo</h4>
              <div className="input">
                <div>
                  <input type="file" style={{ display: 'none' }} ref={fileInputRef} onChange={handleFileChange} />
                  <button style={{ textAlign: 'center' }} type="button" className="btn btn-success-outline" onClick={handleChooseFile}>Escolher Arquivo</button>
                  {selectedFile && newEntrada?.arquivo  &&(
                    <div>
                      <p>Arquivo selecionado: {selectedFile?.name}</p>
                      <button className="btn btn-success" onClick={handleRemoveFile}>Remover</button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            
            
                <div className="actions">
                  <button type="submit" onClick={() => setModal(!modal)} className="btn btn-success">Salvar</button>
                    {
                      !newEntrada.entradaId &&
                        <div className="field">
                          <h4>Replicar Entrada X meses</h4>
                          <div className="input">
                            <Input type="text" key='a' name="replicacao"  value={replicacao} onChange={handleOnChangeReplicacao} />
                          </div>
                        </div>
                    }
                  <button type="button" onClick={() => resetEntrada()} className="btn btn-danger">Voltar</button>
                </div>
            
              
            
            
          </form>
          </SectionModal>
            <button
              className="buttonClosePreview"
              onClick={() => resetEntrada()}
            >
              <IconRemove width="22px" height="22px" />
              Fechar modal
            </button>
          
        </ContainerModal>

      </ModalDefault>
    </Container>
  );
}
